// extracted by mini-css-extract-plugin
export default {"empty":"AdTable_empty__8dGDW","emptyText":"AdTable_emptyText__daBl+"};